var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M3.58008 6.59979C3.58008 5.87077 4.17106 5.27979 4.90008 5.27979H18.1001C18.8291 5.27979 19.4201 5.87077 19.4201 6.59979V7.91979H3.58008V6.59979Z",
    fill: "#919EAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M3.58008 7.91992V15.3999C3.58008 16.1289 4.17106 16.7199 4.90008 16.7199H18.1001C18.8291 16.7199 19.4201 16.1289 19.4201 15.3999V7.91992H3.58008Z",
    fill: "#919EAB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.90039,
    y: 9.78955,
    width: 3.96,
    height: 2.2,
    rx: 1.1,
    fill: "#919EAB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.48,
    x: 9.52051,
    y: 9.78955,
    width: 3.96,
    height: 2.2,
    rx: 1.1,
    fill: "#919EAB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.48,
    x: 14.1406,
    y: 9.78955,
    width: 3.96,
    height: 2.2,
    rx: 1.1,
    fill: "#919EAB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.48,
    x: 4.90039,
    y: 12.6494,
    width: 3.96,
    height: 2.2,
    rx: 1.1,
    fill: "#919EAB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.24,
    x: 9.52051,
    y: 12.6494,
    width: 3.96,
    height: 2.2,
    rx: 1.1,
    fill: "#919EAB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.24,
    x: 14.1406,
    y: 12.6494,
    width: 3.96,
    height: 2.2,
    rx: 1.1,
    fill: "#919EAB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChart);
export default __webpack_public_path__ + "static/media/ic_chart.983513b00d25e448857febb725bd2486.svg";
export { ForwardRef as ReactComponent };